export enum DomainType {
    Radiology = 'Radiology',
    Physio = 'Physio',
    Doctor = 'Doctor'
}

export enum DomainUrl {
    Radiology = 'admin.plusradiology.ai',
    Localhost = 'localhost',
    IfourConsultancy = 'ifour-consultancy.net'
}
